/**
 * Utility Functions - Class Name Merger
 * 
 * Combines clsx and tailwind-merge for conditional class name handling
 */

import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * Merge class names with Tailwind CSS conflict resolution
 * 
 * @param inputs - Class values to merge
 * @returns Merged class string with Tailwind conflicts resolved
 * 
 * @example
 * cn("px-4 py-2", isActive && "bg-primary", "px-6")
 * // Returns: "py-2 bg-primary px-6" (px-6 overrides px-4)
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
